import Axios, { AxiosError } from "axios";
import { useQuery } from "react-query";
import { legendKeys } from "src/query-keys";
import { Legend, APIError } from "src/types";

function deserialize(data: Legend): Legend {
  return data;
}

export function useLegend(legendPath: string) {
  async function queryFn(legendPath: string): Promise<Legend> {
    const result = await Axios.get(`/planning-api/${legendPath}`);
    return deserialize(result.data);
  }

  return useQuery<Legend, AxiosError<APIError>>(legendKeys.detail(legendPath), () => queryFn(legendPath));
}
